/* unplugin-vue-components disabled */import script from "./ScrollPane.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollPane.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollPane.vue?vue&type=style&index=0&id=2ce3b788&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce3b788"]])

export default __exports__